import { hotjar } from 'react-hotjar';
const HOTJAR_SITE_ID = import.meta.env.VITE_HOTJAR_SITE_ID;

export function hasCookieConsent() {
  // Read the consent value and expiration timestamp from local storage.
  const consentValue = localStorage.getItem('cookie-consent');
  const expirationTimestamp = localStorage.getItem('cookie-consent-expiration');

  // Check if the user has given consent or rejected cookies and if the expiration timestamp is still valid.
  if (
    (consentValue === 'accepted' || consentValue === 'rejected') &&
    expirationTimestamp &&
    new Date().getTime() < parseInt(expirationTimestamp)
  ) {
    return true;
  }

  return false;
}

export function handleCookieConsent(accepted: boolean) {
  // Update the consent status in a cookie or local storage.
  const consentValue = accepted ? 'accepted' : 'rejected';

  // Set the expiration time (in milliseconds) for the consent value.
  const expiresIn = 30 * 24 * 60 * 60 * 1000; // 30 days
  const expirationTimestamp = new Date().getTime() + expiresIn;

  // Store the consent value and expiration timestamp.
  localStorage.setItem('cookie-consent', consentValue);
  localStorage.setItem(
    'cookie-consent-expiration',
    expirationTimestamp.toString()
  );

  if (accepted && HOTJAR_SITE_ID) {
    const hotjarSiteIsNumber = !isNaN(Number(HOTJAR_SITE_ID));

    // Check if Hotjar is already initialized.
    // Hotjar sets a global variable called `hj` when initialized.
    if (typeof window.hj === 'undefined' && hotjarSiteIsNumber) {
      // Initialize Hotjar if it's not initialized yet.
      hotjar.initialize({
        id: Number(HOTJAR_SITE_ID),
        sv: 6,
      });
    }
  }
}

export const NOTIFICATION_TIME = 2 * 60 * 1000;
